import "../css/constants.css"
import {Flex} from "rebass";
import {useWindowDimensions} from "../contexts/WindowDimensionsContext";

interface IProps {
    title: string;
    subtitle?: string;
    children?: React.ReactNode;
}

export default function PageTitle(props: IProps) {
    const windowDimensions = useWindowDimensions()

    return (
        <Flex flexDirection={windowDimensions.wWCheck(700) ? "row" : "column"} alignItems={"center"} style={{marginLeft: "10px", color: "var(--Black)", gap: "15px"}}>
            <Flex justifyContent={"center"}>
                <h2 className="mb-0 text-3xl font-black" style={{fontWeight: "800"}}>
                    {props.title}
                    {props.subtitle && (
                        <span className="fw-normal text-700 ms-3">
                            {props.subtitle}
                        </span>
                    )}
                </h2>
            </Flex>
            {props.children && <Flex width={"100%"} flexWrap={"wrap"} flexDirection={windowDimensions.wWCheck(500) ? "row" : "column"} marginLeft={windowDimensions.wWCheck(700) ? "40px" : ""} justifyContent={windowDimensions.wWCheck(700) ? "space-between" : "center"} style={{gap: "15px"}}>
                props.children
            </Flex>}
        </Flex>
    );
}
